export default "__VITE_ASSET__c5869762__"